export default __webpack_public_path__ + "static/media/junk7.c9172907.svg";